
<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol style="font-size: 25px;" col="6">
               الدفعيات التي لم تكتمل
            </CCol>
              <CCol col="6" style="text-align: left;">
                <CButton  to="/payments/paid"  square color="primary">
                    <CIcon class="c-icon" name="cil-chevron-top" /> &emsp; الدفعيات المكتملة
                </CButton>
            </CCol>
        </CRow>
        </CCardHeader>
        <CCardBody>
          <!-- Using the VdtnetTable component -->
          <vdtnet-table
            ref="table"
            :fields="fields"
            :opts="options"
            @show="doAlertShow"
             @approve="doAlertApprove"
            @reloaded="doAfterReload"
            @table-creating="doCreating"
            @table-created="doCreated"
          >
          </vdtnet-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import swal from 'sweetalert'
import VdtnetTable from '../VdtnetTable.vue'
export default {
  name: 'Payments',
  components: { VdtnetTable },
  data () {
    return {
      options: {
        ajax: {
          beforeSend: function (xhr) {
            xhr.setRequestHeader(
              'Authorization',
              'Bearer ' + localStorage.token
            )
          },
          url: this.$hostUrl + 'not-paid-payment',
          dataSrc: (json) => {
            return json.data
          }
        },
        buttons: [
          {
            extend: 'print',
            text: '',
            titleAttr: 'طباعة',
            className: 'fa fa-print btn-primary',
            exportOptions: {
              columns: 'th:not(:last-child)'
            }
          },
          {
            extend: 'copy',
            text: '',
            className: 'fa fa-copy btn-warning',
            titleAttr: 'نسخ',
            exportOptions: {
              columns: 'th:not(:last-child)'
            }
          },
          {
            extend: 'excel',
            text: '',
            titleAttr: 'إكسل',
            className: 'fa fa-table btn-success',
            exportOptions: {
              columns: 'th:not(:last-child)'
            }
          }
        ],
        dom:
          "<'row'<'col-sm-6 col-md-6'f><'col-sm-6 col-md-6 added'l>>" +
          "<'row'<'col-sm-12'Btr>>" +
          "<'row'<'col-sm-12 col-md-8'p><'col-sm-12 col-md-4'i>>",
        paging: true,
        language: {
          url: 'https://cdn.datatables.net/plug-ins/1.10.24/i18n/Arabic.json'
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: false,
        order: [2, 'desc'],
        fixedHeader: true,
        saveState: true,
        select: {
          style: 'multi'
        }
      },
      fields: {
        student: {
          label: 'اسم الطالب',
          sortable: true,
          searchable: true,
          defaultOrder: 'desc'
        },
        course: {
          label: 'الدورة',
          sortable: true,
          searchable: true,
          defaultOrder: 'desc'
        },
        created_at: {
          label: 'تاريخ الدفع',
          sortable: true,
          searchable: true,
          defaultOrder: 'desc'
        },
        approve: {
          label: 'حالة الطلب',
          sortable: true,
          searchable: false
        },
        actions: {
          isLocal: true,
          label: 'العمليات',
          defaultContent: '<button href="javascript:void(0);" data-action="show" class="btn btn-info btn-sm" title="عرض الدفعيات"><i class="mdi mdi-square-show-outline"></i> عرض</button>'
        }
      },
      quickSearch: '',
      details: {}
    }
  },
  methods: {
    doLoadTable (cb) {
      this.$http.getJSON(
        this.$hostUrl + 'payment',
        function (data) {
          cb(data.data)
        }
      )
    },
    doAlertShow (data) {
      this.$router.push({ path: `/payments/${data.id}/show`, params: { id: data.id } })
    },
    doAlertApprove (data, row, tr, target) {
      console.log(`deleting item ID: ${data.id}`)
      swal({
        title: 'هل انت متأكد ؟',
        text: 'تم دفع قيمة الدورة كاملة !',
        icon: 'warning',
        buttons: ['لا', 'نعم'],
        dangerMode: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      }).then((willDelete) => {
        if (willDelete) {
          this.$http
            .get(
              `${this.$hostUrl}payment/${data.id}/approve`,
              { _method: 'get' }
            )
            .then((response) => {
              console.log(response)
              swal({ title: response.data.message, buttons: 'تم' })
            })
          const table = this.$refs.table
          setTimeout(() => {
            table.reload()
          }, 1500)
        } else {
          swal({ title: ' تم الغاء العملية !', buttons: 'تم' })
        }
      })
    },
    doAfterReload (data, table) {
      console.log('data reloaded')
    },
    doCreating (comp, el) {
      console.log('creating')
    },
    doCreated (comp) {
      console.log('created')
    },
    doSearch () {
      this.$refs.table.search(this.quickSearch)
    },
    doExport (type) {
      const parms = this.$refs.table.getServerParams()
      parms.export = type
    },
    formatCode (zipcode) {
      return zipcode.split('-')[0]
    }
  }
}
</script>
